import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl text-sm font-semibold transition-[background-color,border-color,color,box-shadow,transform] outline-none disabled:pointer-events-none disabled:opacity-60 active:scale-[0.99] focus-visible:ring-2 focus-visible:ring-primary/35 focus-visible:ring-offset-2 focus-visible:ring-offset-white',
  {
    variants: {
      variant: {
        default:
          'border border-transparent bg-primary text-primary-foreground shadow-[0_8px_20px_rgb(8_21_56_/_16%)] hover:bg-[var(--brand-primary-hover)] active:bg-[var(--brand-primary-active)]',
        secondary: 'border border-slate-200 bg-white text-slate-900 hover:bg-slate-50',
        outline:
          'border border-slate-200 bg-white text-slate-900 hover:border-slate-300 hover:bg-slate-50',
        ghost: 'border border-transparent bg-transparent text-slate-700 hover:bg-slate-100',
        destructive:
          'border border-transparent bg-red-600 text-white shadow-[0_8px_20px_rgb(220_38_38_/_18%)] hover:bg-red-500 active:bg-red-700',
      },
      size: {
        default: 'h-10 px-4 py-2',
        sm: 'h-9 rounded-lg px-3',
        lg: 'h-11 px-6',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { className, variant, size, type = 'button', ...props },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  )
})
